import { z } from "zod";

const UpdateModelSchema = z
  .object({
    id: z.string().uuid(),
    name: z
      .string()
      .min(1, { message: "Name is required." })
      .max(400, { message: "Name must not be longer than 400 characters." }),
    description: z.string().optional().nullable(),
    shortCode: z.string().min(1, { message: "Short code is required" }),
    shortCodeFormat: z.string().optional().nullable(),
    allowAdvancedFeatures: z.boolean(),
    isHighlighted: z.boolean(),
  })
  .strict();

export default UpdateModelSchema;
